import { Email, Phone } from '@mui/icons-material'
import {
  Box,
  Button,
  IconButton,
  Link,
  TableCell,
  Typography,
} from '@mui/material'

import React, { useState } from 'react'

import { getImportanceColor } from '../utils/color'

import PhoneModal from '../customer/task/PhoneModal'
import { grey } from '@mui/material/colors'
import TaskModalWrapper from '../customer/task/TaskModalWrapper'
import useAlert from '../hooks/useAlert'
import EmailModal from '../customer/task/EmailModal'

export const sortDirs = [null, 'DESC', 'ASC']

export const selectableColumns = [
  {
    label: 'Next Step',
    key: 'nextStep',
    selected: true,
  },
  {
    label: 'Importance',
    hideInHeader: true,
    key: 'importanceTypeId',

    getDisplay: (d, key) => {
      return (
        <TableCell
          key={key}
          sx={{
            border: '1px solid rgba(224, 224, 224, 1)',
            p: 0,
            height: '40px',
            width: '20px',
            backgroundColor: getImportanceColor(d.importanceTypeId),
          }}
        ></TableCell>
      )
    },
    width: '12px',
    selected: true,
  },
  {
    label: 'Account Name',
    key: 'name',
    selected: true,
    disabled: true,
    getDisplay: (d, key) => {
      return (
        <TableCell
          key={key}
          sx={{
            border: '1px solid rgba(224, 224, 224, 1)',

            border: `1px solid ${grey[300]}`,
            position: 'sticky',
            left: 0,
            backgroundColor: 'white',
            zIndex: 1,
          }}
        >
          <Button
            // endIcon={<OpenInNew />}
            href={`/customers/${d.id}?from=lists`}
          >
            {d.name}
          </Button>
        </TableCell>
      )
    },
  },
  { label: 'Status', key: 'statusType', selected: true },
  { label: 'Outcome', key: 'outcome', selected: true },
  {
    label: 'Primary Contact Name',
    key: 'primaryContactName',
    selected: true,
  },
  {
    label: 'Phone',
    key: 'primaryPhone',
    selected: true,
    getDisplay: (d, key) => {
      return (
        <ModalIconDisplay
          key={key}
          IconComponent={Phone}
          ModalComponent={PhoneModal}
          value={d.primaryPhone}
          keyVal={key}
          customer={d}
        />
      )
    },
  },
  {
    label: 'Primary Email',
    key: 'primaryEmail',
    selected: true,
    getDisplay: (d, key) => {
      return (
        <ModalIconDisplay
          key={key}
          IconComponent={Email}
          ModalComponent={EmailModal}
          value={d.primaryEmail}
          keyVal={key}
          customer={d}
        />
      )
    },
  },

  { label: 'Sales Rep', key: 'accountOwners', selected: true },

  { label: 'All Pipelines', key: 'pipelines', selected: false },
  {
    label: 'Opportunities',
    key: 'opportunitiesPipelineStage',
    selected: false,
  },
  {
    label: 'Implementation',
    key: 'implementationPipelineStage',
    selected: false,
  },
  { label: 'Marketing', key: 'marketingPipelineStage', selected: false },
  { label: 'Tickets', key: 'ticketPipelineStages', selected: false },
  { label: 'Lead Source', key: 'leadSource' },

  {
    label: 'Actual Revenue',
    key: 'totalClosedRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },

  {
    label: 'Actual One Time Revenue',
    key: 'pastOneTimeRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },
  {
    label: 'Actual Past Recurring Revenue',
    key: 'pastRecurringRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },

  {
    label: 'Potential Revenue',
    key: 'totalPotentialRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },

  {
    label: 'Potential One Time Revenue',
    key: 'potentialOneTimeRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },
  {
    label: 'Potential Recurring Revenue',
    key: 'potentialRecurringRevenue',
    startAdornment: '$',
    selected: true,
    sum: true,
  },

  { label: 'Days to Close', key: 'daysToClose', endAdornment: ' days' },
  { label: 'Percent to Close', key: 'percentToClose', endAdornment: '%' },
  {
    label: 'Product of Interest',
    key: 'products',
    keys: ['products', 'productOfInterest'],
  },
  { label: 'Industry', key: 'industry' },
  {
    label: 'Tickets',
    key: 'tickets',
    getExport: (d) => {
      const tickets = d.tickets || []
      let str = ``
      tickets.forEach((t) => {
        str += `#${t.id || ''} ${t.category || ''} ${t.department || ''}; `
      })

      return str
    },
    getDisplay: (d, key) => {
      const tickets = d.tickets

      return (
        <TableCell
          key={key}
          sx={{
            border: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          {tickets &&
            tickets.map((t, i) => (
              <>
                <Link
                  key={i}
                  href={`/customers/${d.id}?from=lists&ticketId=${t.id}`}
                  about='_blank'
                >
                  #{t.id} {t.category} {t.department}
                </Link>
                {i !== tickets.length - 1 && <br></br>}
              </>
            ))}
        </TableCell>
      )
    },
  },
  {
    label: 'Tasks',
    key: 'tasks',
    getExport: (d) => {
      const tasks = d.tasks || []

      let str = ``
      tasks.forEach((t) => {
        const val = `${t.type || ''} ${t.outcome || ''} ${
          t.taskOutcome || ''
        } ${t.identityName || ''}; `

        str += val
      })

      return str
    },
    getDisplay: (d, key) => {
      const tasks = d.tasks

      return (
        <TableCell
          key={key}
          sx={{
            border: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          {tasks &&
            tasks.map((t, i) => (
              <>
                <Typography key={i}>
                  {t.type}, {t.outcome}
                  {t.outcome && ', '} {t.taskOutcome}
                  {t.taskOutcome && ', '} {t.identityName}
                  {', '}
                  {new Date(t.completedOn).toLocaleDateString()}
                </Typography>
                {i !== tasks.length - 1 && <br></br>}
              </>
            ))}
        </TableCell>
      )
    },
  },
  {
    label: 'Task Count',
    key: 'taskCount',
    getExport: (d) => d.tasks?.length || 0,
    getDisplay: (d, key) => {
      return (
        <TableCell
          key={key}
          sx={{
            border: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          {d.tasks?.length || 0}
        </TableCell>
      )
    },
  },
]

const ModalIconDisplay = ({
  IconComponent,
  ModalComponent,
  keyVal,
  value,
  customer,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { createAlert } = useAlert()
  return (
    <TableCell
      key={keyVal}
      sx={{ border: '1px solid rgba(224, 224, 224, 1)', lineBreak: 'anywhere' }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: value ? 'space-between' : 'center',
          width: '100%',
        }}
      >
        <span>
          {value || (
            <Typography sx={{ color: grey[600], fontSize: '14px' }}>
              <i>(None)</i>
            </Typography>
          )}
          {value && (
            <IconButton sx={{ ml: 1 }} onClick={() => setIsOpen(true)}>
              <IconComponent color={'primary'} />
            </IconButton>
          )}
        </span>
      </Box>
      {isOpen && (
        <TaskModalWrapper
          isOpen={isOpen}
          Component={ModalComponent}
          onSave={() => {
            setIsOpen(false)
            createAlert({ message: 'Task created successfully' })
          }}
          onClose={() => setIsOpen(false)}
          contact={null}
          customer={customer}
        ></TaskModalWrapper>
      )}
    </TableCell>
  )
}
